export const pages = {
	'boltHome': { id: 'boltHome', page: 'home', getter: () => import(/* webpackChunkName: 'boltHome' */ 'components/bolt/home/home') }
};
export const sections = [
	{ id: 'boltSynopsis', getter: () => import(/* webpackChunkName: "boltSynopsis" */ 'components/bolt/synopsis/synopsis'), component: 'synopsis' },
	{ id: 'versus', getter: () => import(/* webpackChunkName: "versus" */ 'components/bolt/text/text'), component: 'text' },
	{ id: 'boltYoutubePlaylist', getter: () => import(/* webpackChunkName: "boltYoutubePlaylist" */ 'components/bolt/youtubePlaylist/youtubePlaylist'), component: 'youtubePlaylist' }
];
export const sectionsWithParent = [

];
import SidePanelLoader from 'components/bolt/sidePanelLoader/sidePanelLoader';
export { SidePanelLoader };
import VideoOverlayLoader from 'components/bolt/videoOverlayLoader/videoOverlayLoader';
export { VideoOverlayLoader };
